import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const signup = (tokens: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.createPassword,
    method: 'POST',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { signup }
